module.exports = __webpack_public_path__ + "media/images/new/icons/scb-7000649b972741ac4370be299d2bfc3f.png";